// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","social":"Footer_social__6J-nV","content":"Footer_content__EyWJb","logo1":"Footer_logo1__3WtMs","logo2":"Footer_logo2__idFrw"};